<template>
    <div class="hidden sm:flex text-20">
        <router-link to="/" class="text-tc-blue-1">{{ lbl.home.tab_menu.main }}</router-link>
        <div class="px-1 text-tc-blue-1"> / </div>
        <router-link to="/mission" class="text-tc-blue-1">{{ lbl.home.tab_menu.mission }}</router-link>
        <template v-if="pathLink1">
            <div class="px-1 text-tc-blue-1"> / </div>
            <router-link :to="pathLink1.url" :class="pathLink1.url ? 'text-tc-blue-1' :'text-tc-gray-3'">
                {{pathLink1.name}}
            </router-link>
        </template>
        <template v-if="pathLink2">
            <div class="px-1 text-tc-blue-1"> / </div>
            <router-link :to="pathLink2.url" :class="pathLink2.url ? 'text-tc-blue-1' :'text-tc-gray-3'">
                {{pathLink2.name}}
            </router-link>
        </template>

    </div>
</template>
<script>
import LocaleMixin from '@/mixin/LocaleMixin'
export default {
    name: 'PathLink',
    mixins: [LocaleMixin],
    props: {
        pathLink1: { type:Object , default: null },
        pathLink2: { type:Object , default: null },
    },
}
</script>
<style lang="scss" scoped>
</style>
